import React from 'react';

const About = () => {
  return (
    <div className="about-page">
      <div className="page-hero">
        <div className="container">
          <h1>About SolarEnergy</h1>
          <p>Leading solar solutions provider in Maharashtra since 2010</p>
        </div>
      </div>
    </div>
  );
};

export default About;